/**
 * Deeplink utilities for building activity/conversation URLs
 */
/**
 * Build the path portion of an activity deeplink (e.g. /dashboard/activity?threadId=xxx&scrollTo=end)
 */
export function buildActivityDeeplinkPath(params) {
    const searchParams = new URLSearchParams();
    searchParams.set('threadId', params.threadId);
    if (params.messageId)
        searchParams.set('messageId', params.messageId);
    if (params.companyId)
        searchParams.set('companyId', params.companyId);
    if (params.sessionId)
        searchParams.set('sessionId', params.sessionId);
    if (params.scrollTo)
        searchParams.set('scrollTo', params.scrollTo);
    return `/dashboard/activity?${searchParams.toString()}`;
}
/**
 * Build full activity deeplink URL (appUrl + path)
 */
export function buildActivityDeeplink(appUrl, params) {
    const base = appUrl.replace(/\/$/, '');
    return `${base}${buildActivityDeeplinkPath(params)}`;
}
/**
 * Build a session deeplink URL.
 * Produces: {appUrl}/dashboard/activity?threadId=xxx&sessionId=yyy
 */
export function buildSessionDeeplink(appUrl, threadId, sessionId) {
    return buildActivityDeeplink(appUrl, { threadId, sessionId });
}
/**
 * Build a session deeplink URL scoped to a company.
 * Produces: {appUrl}/dashboard/activity?threadId=xxx&sessionId=yyy&companyId=zzz
 */
export function buildCompanySessionDeeplink(appUrl, threadId, sessionId, companyId) {
    return buildActivityDeeplink(appUrl, { threadId, sessionId, companyId });
}
//# sourceMappingURL=deeplink.js.map